<template>
  <div>
    <!-- 列表开始 -->
    <div class="BlockList" v-show="flag">
      <div class="BlockList-W">
        <div class="owner">
          <div class="owner_left">
            <div class="owner_limg">
              <img src="../../../assets/pc/Logo/tu.png" />
            </div>
            <div class="owner_email">{{ userEmail }}</div>
            <div class="owner_line"></div>
            <div class="owner_address">
              <img src="../../../assets/pc/Logo/tu1.png" />
              <div class="owner_tit">Verified Addresses</div>
            </div>
            <div class="owner_out" @click="signout">Sign Out</div>
          </div>
          <div class="owner_right">
            <div class="owner_box">
              <div class="owner-rtit">
                <div class="owner_rtit1">My Verified Addresses</div>
                <div class="owner_rtit2" @click="add">
                  <img src="../../../assets/pc/Logo/add3.png" />
                  <div>Add Address</div>
                </div>
              </div>
              <div class="owner-ctit">
                Verification of contract address ownership is a process aimed at
                confirming the legitimate ownership of a wallet address to
                establish an association with a smart contract (in this case,
                the 'Transformers' smart contract). This verification process
                ensures that the contract is linked to the correct owner,
                allowing users to manage token-related information associated
                with that address.<router-link
                  to="/pc/instructions"
                  target="_blank"
                  ><span>Verify Address Ownership</span></router-link
                >
              </div>
              <div class="seacherc">
                <input
                  type="text"
                  id="inputvalue"
                  v-model.trim="value"
                  @keyup.enter="search"
                  placeholder="Search  Address"
                />
                <div class="button" @click="search">
                  <img src="@/assets/pc/Logo/add2.png" />
                </div>
              </div>
              <div class="owner_list">
                <div class="owner_head">
                  <div class="headli">Address</div>
                  <div class="headli">Quick Links</div>
                  <div class="headli">Verified Date</div>
                </div>
                <div v-if="list.length > 0 && userEmail !== null">
                  <!-- <div> -->
                  <div
                    class="owner_cont"
                    v-for="(item, index) in list"
                    :key="index"
                  >
                    <div class="owner_contli">
                      <!-- <div>
                        <img
                          src="../../../assets/pc/Logo/add1.png"
                        
                        />
                      </div> -->
                      <div style="display: flex">
                        <div style="display: flex; width: 320px">
                          <img
                            src="../../../assets/pc/Logo/add1.png"
                            class="imga"
                          />
                          <div
                            style="
                              width: 300px;
                              overflow: hidden;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              -o-text-overflow: ellipsis;
                            "
                            @click="goto(item.contractAddress, item.standard)"
                          >
                            {{ item.contractAddress }}
                          </div>
                        </div>

                        <img
                          src="@/assets/pc/Index/fz.png"
                          v-clipboard:copy="item.contractAddress"
                          v-clipboard:success="copyClicked"
                          v-clipboard:error="onError"
                          class="imgb"
                          style="cursor: pointer; margin-top: 8px"
                        />
                      </div>
                    </div>
                    <div class="owner_contli">
                      <img
                        class="imga"
                        src="@/assets/pc/Logo/add4.png"
                        @click="update(item.contractAddress)"
                      />
                      <img
                        class="imgb"
                        src="../../../assets/pc/Logo/add44.png"
                        @click="deletes(item.contractAddress)"
                      />
                    </div>
                    <div class="owner_contli">{{ item.createTime }}</div>
                    <Delte
                      v-show="addflag3"
                      :contractAddress="contractAddress"
                      @delflog="delflog($event)"
                    ></Delte>
                  </div>
                  <div class="block">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="8"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div v-else>
                  <div class="listbox">
                    <div class="listboxtit">
                      You have yet to verify any address
                    </div>
                    <div class="listboxtit1">Please try again later</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表结束 -->
    <!-- 添加地址开始 -->
    <div class="BlockList1" v-show="addflag">
      <div class="add_address">
        <div class="add_close">
          <img src="../../../assets/pc/Logo/close.png" @click="addclose" />
        </div>
        <div class="add_box">
          <div class="add_tit">Verify Address Ownership</div>
          <div class="add_tit1">
            Find out more about<router-link
              to="/pc/instructions"
              target="_blank"
              ><span>Verify Address Ownership</span></router-link
            >
          </div>
          <div class="add_con">
            <div class="add_contit">Please enter contract address</div>
            <div class="add_input">
              <input type="text" v-model.trim="address" />
            </div>
            <div
              class="btn"
              :class="{ btn1: isFormValid() }"
              @click="addaddress"
            >
              Continue
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址结束 -->
    <!-- 验证签名开始 -->
    <div class="BlockList2" v-show="addflag1">
      <div class="verify">
        <div class="verify_close">
          <img src="../../../assets/pc/Logo/close.png" @click="addclose1" />
        </div>
        <div class="verify_box">
          <div class="verifytit">Verify Address Ownership</div>
          <div class="verifytit1">
            Find out more about
            <router-link to="/pc/instructions" target="_blank"
              ><span>Verify Address Ownership</span></router-link
            >
          </div>
          <div class="verifypt">Contract Creator</div>
          <div class="verifypc">
            <div class="text">{{ creators }}</div>
          </div>
          <div class="verifypt">
            Message To Sign
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="messagesign"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="verifypc">
            <div class="text">
              {{ messagesign }}
            </div>
          </div>
          <div class="verifypt">Signature Hash</div>
          <div class="verifypc1">
            <input type="text" v-model.trim="hash" />
            <div class="button" @click="connect">Sign with Tree Wallet</div>
          </div>
          <div
            class="Ownership"
            :class="{ Ownership1: isFormValid1() }"
            @click="Ownership"
          >
            Verify Ownership
          </div>
        </div>
      </div>
    </div>
    <!-- 二维码开始 -->
    <div class="BlockList2" v-show="addflag2">
      <div class="erweima">
        <div class="close">
          <img src="../../../assets/pc/Logo/close.png" @click="closea" />
        </div>
        <div class="erweitit">
          Please use Tree Wallet<br />
          to scan the QR code <br />below for signing
        </div>
        <!-- <div class="imgs">
          
        </div> -->
        <div class="imgborder">
          <div ref="qrcode" id="qrcode" class="imgs"></div>
        </div>
        <div class="btton" @click="getSignature">I have scanned and signed</div>
      </div>
      <!-- 二维码结束 -->
    </div>
    <!-- 验证签名结束 -->
    <!-- 询问是否删除开始 -->
    <!-- <div class="BlockList2" v-show="addflag3">
      <div class="delet">
        <div class="box">
          <div class="deletit">Confirm the Release of Ownership</div>
          <div class="delflex">
            <div class="deleterr" @click="Cancel">Cancel</div>
            <div class="deletok" @click="Confirm">Confirm</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 询问是否删除结束 -->
  </div>
</template>

<script>
import { getSubStr } from "@/utils/utils";
import QRCode from "qrcodejs2";
import axios from "axios";
import { timestampConvertTime2 } from "@/utils/utils.js";
import Delte from "@/views/pc/Login/delte.vue";
export default {
  data() {
    return {
      value: "",
      flag: true,
      flag1: false,
      addflag: false,
      addflag1: false,
      addflag2: false,
      addflag3: false,
      userId: "",
      jwtToken: "",
      list: [], //合约列表
      total: "",
      userEmail: "",
      url: "https://explorer.tfsc.io/tfscBrowser/user/",
      // url: "http://192.168.1.123:9200/tfscBrowser/user/",
      address: "",
      creator: "",
      creators: "",
      messagesign: "",
      signUUID: "",
      sign: "",
      //二维码开始
      qrcode: {},
      time_Interval: "", // 定时器
      time_Interval_time: 60000, // 定定时器时间
      hash: "",
      pageNum: 1,
      userId: "",
      delete: false,
      contractAddress: "",
      Walletaddress: "",
    };
  },
  components: {
    Delte,
  },
  created() {
    // window.addEventListener("email", this.signout);
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.path === "/pc/Ownership") {
          this.userId = localStorage.getItem("userId");
          //   console.log(this.userId);
          // 在这里监听email的变化
          this.userEmail = localStorage.getItem("email");
          //  console.log(this.userEmail);
          this.jwtToken = localStorage.getItem("jwtToken");
          if (
            this.userEmail == null ||
            this.userEmail == undefined ||
            this.userEmail == ""
          ) {
            //this.$message("请重新登录");
            //  this.$message("Please log in again");
            this.$router.push("/pc/Index");
          }
          if (
            this.userEmail !== "" ||
            this.userEmail !== null ||
            this.userEmail !== undefined
          ) {
            this.userEmail = getSubStr(this.userEmail, 0, 5);
            // this.getlist();
          }
          // console.log(this.userEmail);
          // console.log(this.userId);
          if (this.userId !== "") {
            // console.log("再次刷新");
          }
        }
      },
      deep: true,
      immediate: true,
    },
    // 监听localStorage中email的变化
    userEmail: function (newVal, oldVal) {
      // console.log(newVal);
      // console.log("Email 发生变化", newVal, oldVal);
      // 在这里可以执行相应的操作
    },
  },

  mounted() {
    this.accountsChanged();
    this.userId = localStorage.getItem("userId");
    this.jwtToken = localStorage.getItem("jwtToken");
    if (
      this.userEmail == null ||
      this.userEmail == undefined ||
      this.userEmail == ""
    ) {
      //  this.$message("请重新登录11");
      //  this.$message("Please log in again");
      this.$router.push("/pc/Index");
    }
    if (
      this.userEmail !== "" ||
      this.userEmail !== null ||
      this.userEmail !== undefined
    ) {
      this.userEmail = localStorage.getItem("email");
      // console.log(this.userEmail);
      if (this.userEmail !== null) {
        this.userEmail = getSubStr(this.userEmail, 0, 5);
      }
      //this.pageNum=1;
      this.getlist();
    }
    // console.log(this.jwtToken);
    // this.BlockList();
    //
    //二维码开始
    // const that = this;
    // if (!this.time_Interval) {
    //   that.init();
    // }
    // this.time_Interval = window.setInterval(function () {
    //   that.init();
    // }, that.time_Interval_time);
  },
  methods: {
    async connect() {
      if (window.treeWallet) {
        this.Walletaddress = await window.treeWallet.connect();
        // console.log(this.Walletaddress.toString());
        //  console.log(this.creators);
        // console.log(this.messagesign.toString());
        if (this.Walletaddress == this.creators) {
          try {
            const res = await window.treeWallet.signMessage(
              this.messagesign.toString()
            );
           // console.log(res);
            this.hash = res;
          } catch (error) {
            //console.log(error);
          }
        } else {
          //console.log("值不同");
          this.$message("The wallet link address is incorrect");
          this.accountsChanged();
        }
      }
    },
    async accountsChanged() {
      try {
        await window.treeWallet.on("accountsChanged", (accounts) => {
          //console.log(accounts);
        });
      } catch (err) {
       // console.log(err);
      }
    },
    // async connect() {
    //   try {
    //     if (window.treeWallet) {
    //       if (window.treeWallet.isConnected == true) {
    //         console.log(window.treeWallet.address);
    //         await window.treeWallet.connect();
    //         await window.treeWallet.on("accountsChanged", (accounts) => {
    //           console.log('23232323');
    //         })
    //       } else if (window.treeWallet.isConnected == false) {
    //         await window.treeWallet.connect();
    //         console.log('断链接了');
    //       }
    //     }
    //   } catch (error) {
    //     this.$message(error);
    //     //console.error("An error occurred:", error);
    //   }
    //   // console.log(this.messagesign);
    //   // console.log(this.creators);
    //   // if (window.treeWallet) {
    //   //   this.Walletaddress = await window.treeWallet.connect();
    //   //   console.log(this.Walletaddress);
    //   //   console.log(this.Walletaddress.toString());
    //   //   if (this.Walletaddress == this.creators) {
    //   //     try {
    //   //       const res = await window.treeWallet.signMessage(
    //   //         this.messagesign.toString()
    //   //       );
    //   //       console.log(res);
    //   //       this.hash = res;
    //   //     } catch (error) {
    //   //       console.log(error);
    //   //     }
    //   //   } else {
    //   //     console.log("The wallet link address is incorrect");
    //   //  //   this.$message("The wallet link address is incorrect");
    //   //     this.connect();
    //   //     // try {
    //   //     //   await window.treeWallet.on("accountsChanged", (accounts) => {
    //   //     //     this.Walletaddress = accounts;
    //   //     //     console.log(accounts);
    //   //     //   });
    //   //     // } catch (err) {
    //   //     //   this.$message(err);
    //   //     // }
    //   //   }
    //   // }
    // },

    isFormValid1() {
      // Check if all required fields have values
      if(this.hash!=='' || this.hash!==null){
        return this.hash.trim() !== "";
      }
    },
    isFormValid() {
      // Check if all required fields have values
      return this.address.trim() !== "";
    },
    // Cancel() {
    //   this.addflag3=false;
    //   this.delete = false;
    // },
    // Confirm() {
    //   this.delete = true;
    //   this.addflag3=false;

    // },
    delflog(val) {
      this.addflag3 = val;
      this.getlist();
    },
    goto(val, value) {
      this.getlist();
      if (value == "ERC-20") {
        this.$router.push({
          path: "/pc/Overview",
          query: { contractAddress: val },
        });
      } else {
        this.$router.push({
          path: "/pc/NFTsdetail",
          query: { contractAddress: val },
        });
      }
    },
    closea() {
      this.addflag2 = false;
      this.addflag1 = true;
    },
    //修改
    update(val) {
      this.getlist();
      // console.log(localStorage.getItem("email"));
      this.userEmail = localStorage.getItem("email");
      //  console.log(this.userEmail);
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        // this.$message("Please log in again111");
        this.$router.push("/pc/Index");
        return false;
      }
      if (
        this.userEmail !== null ||
        this.userEmail !== "" ||
        this.userEmail !== undefined
      ) {
        // this.getlist();
        //this.addflag3 = true;
        // this.$router.push('/pc/Information', query: { address: query });
        this.$router.push({
          path: "/pc/Information",
          query: { userId: this.userId, contractAddress: val },
        });
      }

      // console.log(this.userId);
      // console.log(this.creator);
    },
    //提交验证合约
    Ownership() {
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        this.$message("Please log in again456");
        this.$router.push("/pc/Index");
        return false;
      }
      if (this.hash == "") {
        this.$message("Hash is required");
        return false;
      } else {
        const params = {
          userId: this.userId,
          contractAddress: this.creator,
          message: this.messagesign,
          signatureHash: this.hash,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let config = {
          headers: {
            "Content-Type": "application/json",
            jwtToken: this.jwtToken,
          },
        }; //修改请求头

        // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
        let url = this.url + "commitVerifyContract";
        axios
          .post(url, formData, config)
          .then((res) => {
            // console.log(res.data.result);
            if (res.data.code == 200) {
              // console.log("第二部签名开始");
              // this.$router.push("/pc/Ownersuccess");
              this.$router.push({
                path: "/pc/Ownersuccess",
                query: { contractAddress: this.creator },
              });
            } else if (res.data.code == 401) {
              //  console.log("进行了异地登录1111");

              localStorage.removeItem("userId");
              localStorage.removeItem("email");
              localStorage.removeItem("jwtToken"); //  this.$message(res.data.result);
              this.signout();
            } else {
              // this.$router.push("/pc/Ownererror");
              this.$router.push({
                path: "/pc/Ownererror",
                query: { contractAddress: this.creator },
              });
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
            //  console.log(err);
          });
      }
    },
    init() {
      // this.Address = "signUUID:" + this.signUUID;
      this.sign = {
        signUUID: this.signUUID,
        message: this.messagesign,
      };
      // console.log(this.signUUID);
      // console.log(this.messagesign);
      // console.log(this.sign);
      this.sign = JSON.stringify(this.sign);
      this.Address = "signUUID:" + this.sign;
      //this.messagesign
      // console.log(this.messagesign);
      // console.log(this.Address);
      //  const that = this
      const width = (window.innerWidth / 100) * 40; // 此行代码表示二维码的宽度为屏幕宽度的40%，width 不支持百分比、不同设备的像素不一样所以此处这样写
      // 此处可以根据业务进行异步处理，动态获取二维码参数，刷新二维码
      // let qrCodeContent = this.Address; // 伪代码
      // console.log(qrCodeContent);
      // 先清除二维码再重新生成
      if (this.qrcode.clear) {
        // this.qrcode.clear()
        this.$refs.qrcode.innerHTML = "";
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: this.Address,
        width: 180,
        height: 180,
        colorDark: "#000", // Light color for dark modules
        colorLight: "#fff", // Dark color for light modules
        correctLevel: 3,
        border: 4,
        borderColor: "#fff",
        //correctLevel: QRCode.CorrectLevel.H, //容错级别
      });
      this.qrcode._el.title = "";
    },
    //扫完二维码的时候点击出发
    async getSignature() {
      //console.log("添加地址");
      this.addflag2 = false;
      this.addflag1 = true;
      const params = {
        userId: this.userId,
        signUUID: this.signUUID,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "getSignatureHashBySignUUID";
      axios
        .post(url, formData, config)
        .then((res) => {
          //  console.log(res.data.result);
          if (res.data.code == 200) {
            //  console.log("第二部签名开始");
            this.hash = res.data.result;
            // this.list = res.data.result.list;
            // this.total = res.data.result.count;
          } else if (res.data.code == 401) {
            //    console.log("进行了异地登录1111");

            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken"); //  this.$message(res.data.result);
            this.signout();
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          //  console.log(err);
        });
      // let data = await initAddVerifiedContract(formData);
    },
    search() {
      this.pageNum = 1;
      const params = {
        userId: this.userId,
        pageNum: this.pageNum,
        pageSize: 8,
        contractAddress: this.value,
      };

      //   console.log(params);
      let formData = new FormData();

      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "verifiedContractList";
      axios
        .post(url, formData, config)
        .then((res) => {
          if (res.data.code == 200) {
            //  console.log(res.data.result);
            this.list = res.data.result.list;
            for (var i = 0; i < this.list.length; i++) {
              this.list[i].createTime = timestampConvertTime2(
                this.list[i].createTime
              );
            }
            this.total = res.data.result.count;
            this.value = "";
          } else if (res.data.code == 401) {
            // console.log("进行了异地登录1111");

            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken");
            //  this.$message(res.data.result);
            this.signout();
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          //console.log(err);
        });
    },
    //点击展开二维码
    // signerweima() {
    // //  console.log("点击二维码展开");
    //   this.addflag1 = false;
    //   this.addflag2 = true;
    // },
    add() {
      this.getlist();
      // if (this.userEmail == null) {
      //   this.$message("Please log in again");
      //   return false;
      // }
      //   console.log(localStorage.getItem("email"));
      this.userEmail = localStorage.getItem("email");
      // console.log(this.userEmail);
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        // this.$message("Please log in again777");
        this.$router.push("/pc/Index");
        return false;
      }
      if (
        this.suerEmail !== null ||
        this.userEmail !== "" ||
        this.userEmail !== undefined
      ) {
        this.addflag = true;
      }
    },
    //添加窗口关闭
    addclose() {
      this.addflag = false;
      this.address = "";
    },
    //验证窗口关闭按钮
    addclose1() {
      this.addflag1 = false;
      this.address = "";
    },
    //添加地址
    async addaddress() {
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        // this.$message("Please log in again888");
        this.$router.push("/pc/Index");
        return false;
      }
      if (this.address == "") {
        this.$message("Address  is required");
        return false;
      } else {
        // console.log("添加地址");
        const params = {
          userId: this.userId,
          contractAddress: this.address,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let config = {
          headers: {
            "Content-Type": "application/json",
            jwtToken: this.jwtToken,
          },
        }; //修改请求头

        // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
        let url = this.url + "initAddVerifiedContract";
        axios
          .post(url, formData, config)
          .then((res) => {
            // console.log(res.data.result);
            if (res.data.code == 200) {
              // console.log("第二部签名开始");
              this.addflag = false;
              this.addflag1 = true;
              // creator:'',
              // messagesign:''
              this.creator = res.data.result.contractAddress;
              this.creators = res.data.result.address;
              // console.log(this.creator);
              this.messagesign = res.data.result.signMessage;
              this.signUUID = res.data.result.signUUID;

              //   console.log(this.messagesign);
              // this.list = res.data.result.list;
              // this.total = res.data.result.count;
              this.init();
            } else if (res.data.code == 401) {
              //    console.log("进行了异地登录1111");

              localStorage.removeItem("userId");
              localStorage.removeItem("email");
              localStorage.removeItem("jwtToken");
              // this.$message(res.data.result);
              this.signout();
            } else {
              this.$message(res.data.result);
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
            //  console.log(err);
          });
      }
      // let data = await initAddVerifiedContract(formData);
    },
    //退出
    signout() {
      localStorage.removeItem("userId");
      localStorage.removeItem("email");
      localStorage.removeItem("jwtToken");
      // this.$message('Please log in again11111');
      // this.$router.push("/pc/Index");
      this.$router.push({
        path: "/pc/Index",
        query: { userEmail: "" },
      });

      //  window.location.reload();
      //  this.getlist();
    },
    //获取列表
    async getlist() {
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        // this.$message("Please log in again");
        this.$router.push("/pc/Index");
        return false;
      }
      const params = {
        userId: this.userId,
        pageNum: this.pageNum,
        pageSize: 8,
        contractAddress: "",
      };

      //   console.log(params);
      let formData = new FormData();

      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }

      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "verifiedContractList";
      axios
        .post(url, formData, config)
        .then((res) => {
          if (res.data.code == 200) {
            // console.log(res.data.result);
            // console.log(res.data.result.list);
            this.list = res.data.result.list;
            for (var i = 0; i < this.list.length; i++) {
              this.list[i].createTime = timestampConvertTime2(
                this.list[i].createTime
              );
            }
            this.total = res.data.result.count;
            // console.log(this.list);
          } else if (res.data.code == 401) {
            // console.log("进行了异地登录");
            //this.$message("Please log in again");
            //  this.$message('进行了异地登录');
            //  this.$message(res.data.result);
            this.list = "";
            this.userEmail = "";
            this.signout();
            return false;
          }
          // if (res.data.result.code == 200) {
          //   this.lists = res.data.result.list;
          //   console.log(this.lists);

          // }
        })
        .catch((err) => {
          this.$message.error(err.message);
          // console.log(err);
        });
    },
    //删除
    async deletes(val) {
      this.getlist();
      //    console.log(localStorage.getItem("email"));
      this.userEmail = localStorage.getItem("email");
      // console.log(this.userEmail);
      if (
        this.userEmail == null ||
        this.userEmail == "" ||
        this.userEmail == undefined
      ) {
        // this.$message("Please log in again123");
        this.$router.push("/pc/Index");
        return false;
      }

      if (
        this.userEmail !== null ||
        this.userEmail !== "" ||
        this.userEmail !== undefined
      ) {
        this.addflag3 = true;
      }

      this.contractAddress = val;
      // console.log(this.contractAddress);
      this.pageNum = 1;
      //this.getlist();
      // if (this.delete == true) {
      //   console.log("删除");
      //   const params = {
      //     userId: this.userId,
      //     contractAddress: val,
      //   };
      //   console.log(params);
      //   const formData = new FormData();
      //   const item = params;
      //   for (const key in item) {
      //     if (Object.hasOwnProperty.call(item, key)) {
      //       formData.append(key, item[key]);
      //     }
      //   }
      //   let config = {
      //     headers: {
      //       "Content-Type": "application/json",
      //       jwtToken: this.jwtToken,
      //     },
      //   }; //修改请求头

      //   // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      //   let url = this.url + "removeContractVerify";
      //   axios
      //     .post(url, formData, config)
      //     .then((res) => {
      //       console.log(res.data.result);

      //       if (res.data.code == 200) {
      //         console.log("删除成功");
      //         this.getlist();
      //         //this.lists = res.data.result.list;
      //         // console.log(this.lists);
      //       }
      //     })
      //     .catch((err) => {
      //       this.$message.error(err.message);
      //       console.log(err);
      //     });
      // }
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      // document.querySelector("#anchor").scrollIntoView(true);
      // this.setContextData("tiaozhuan1", this.pageNum);
      this.getlist();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-message {
  z-index: 9999999;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;
  /* 其他样式调整，根据需要自行添加 */
}
/deep/.el-input__inner {
  color: #ffffff !important;
}
/deep/.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
/deep/.el-pagination {
  position: absolute;
  left: 50%;
  top: 98%;
  transform: translate(-50%, -98%);
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;

  font-size: 13px;
  font-family: Roboto, Roboto;
  font-weight: 700;
  border: none;
}
/deep/.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

/deep/.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  // height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 13px;
  font-family: Roboto, Roboto;
  font-weight: 700;

  color: #ffffff;
  height: 24px;
  line-height: 24px;
  // line-height: 48px;

  text-align: center;
}
</style>
<style lang="less" scoped>
.BlockList {
  width: 100%;
  background: #13161b;
  // position: relative;
  .BlockList-W {
    //width: 1180px;

    // position: absolute;
    // left: 50%;
    // transform: translate(-50%,0);
    padding-bottom: 36px;
    background: #13161b;
    .owner {
      width: 1180px;
      margin: 0 auto;
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
      .owner_left {
        width: 268px;
        height: 580px;
        background: #0b0c0f;
        border-radius: 20px 20px 20px 20px;
        opacity: 1;
        .owner_limg {
          margin-top: 20px;
          margin-left: 110px;
          border-radius: 50%;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .owner_email {
          margin-top: 12px;
          // margin-left: 67px;
          text-align: center;
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #898b8d;
        }
        .owner_line {
          width: 220px;
          height: 0px;
          opacity: 1;
          border: 1px solid #000000;
          margin-top: 24px;
          margin-left: 24px;
        }
        .owner_address {
          width: 220px;
          height: 47px;
          background: #000000;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          display: flex;
          margin-top: 24px;
          margin-left: 24px;
          cursor: pointer;
          img {
            width: 24px;
            height: 24px;
            margin-top: 11px;
            margin-left: 17px;
          }
          .owner_tit {
            font-size: 18px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #00e79a;
            margin-top: 11px;
            margin-left: 10px;
          }
        }
        .owner_out {
          width: 163px;
          height: 36px;
          line-height: 36px;
          background: #2b2b2b;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.7);
          margin-top: 320px;
          margin-left: 58px;
          text-align: center;
          cursor: pointer;
        }
        .owner_out:hover {
          width: 163px;
          height: 36px;
          line-height: 36px;
          background: #00e79a;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #2b2b2b;
          margin-top: 320px;
          margin-left: 58px;
          text-align: center;
          cursor: pointer;
        }
      }
      .owner_right {
        width: 876px;
        height: 764px;
        background: #000000;
        opacity: 1;
        border-radius: 20px;
        position: relative;
        .owner_box {
          margin: 30px 40px;

          .owner-rtit {
            display: flex;
            justify-content: space-between;
            .owner_rtit1 {
              font-size: 19px;
              font-family: Roboto, Roboto;
              font-weight: 500;
              color: #ffffff;
              line-height: 22px;
            }
            .owner_rtit2 {
              display: flex;
              cursor: pointer;
              img {
                width: 20px;
                height: 20px;
              }
              div {
                font-size: 16px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #ffffff;
                margin-left: 4px;
              }
            }
          }
          .owner-ctit {
            margin-top: 21px;
            height: 84px;
            font-size: 16px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.7);
            line-height: 26px;
            margin-bottom: 40px;
            span {
              font-size: 16px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #00e79a;
              margin-left: 4px;
            }
          }
          .seacherc {
            margin-top: 12px;
            width: 380px;
            height: 40px;
            background: #18191e;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            display: flex;
            input {
              height: 40px;
              border: none;
              margin-left: 20px;
              font-size: 14px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #fff !important;
              width: 320px;
            }

            .button {
              margin-top: 8px;
              margin-right: 16px;
              cursor: pointer;
              img {
                width: 24px;
                height: 24px;
              }
            }
          }
          .owner_list {
            margin-top: 24px;
            .owner_head {
              display: flex;
              width: 796px;
              height: 60px;
              line-height: 60px;
              background: #14151a;
              border-radius: 10px 10px 10px 10px;
              opacity: 1;
              margin-bottom: 9px;
              .headli {
                font-size: 17px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #898b8d;
              }
              .headli:nth-child(1) {
                width: 45%;
                padding-left: 20px;
              }
              .headli:nth-child(2) {
                width: 30%;
                text-align: center;
              }
              .headli:nth-child(3) {
                width: 25%;

                text-align: center;
              }
            }
            .owner_cont:nth-child(8) {
              border-bottom: none;
            }
            .owner_cont {
              display: flex;
              // padding-top: 9px;
              border-bottom: 1px solid #22252e;
              .owner_contli {
                height: 44px;
                line-height: 44px;
                // border-bottom: 1px solid #22252E;
              }

              .owner_contli:nth-child(1) {
                display: flex;
                width: 45%;

                font-size: 15px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #ffffff;
                cursor: pointer;
                .imga {
                  width: 19px;
                  height: 21px;
                  margin-top: 12px;
                  margin-right: 4px;
                  cursor: pointer;
                }
                .imgb {
                  width: 22px;
                  height: 22px;
                  // margin-left: 8px;
                  // margin-top: 12px;

                  cursor: pointer;
                }
              }
              .owner_contli:nth-child(2) {
                width: 30%;
                text-align: center;
                display: flex;

                .imga {
                  margin-top: 8px;
                  width: 24px;
                  height: 24px;
                  margin-left: 80px;
                  cursor: pointer;
                }
                .imgb {
                  margin-top: 8px;
                  width: 24px;
                  height: 24px;
                  margin-left: 19px;
                  cursor: pointer;
                }
              }
              .owner_contli:nth-child(3) {
                width: 25%;
                text-align: center;
                font-size: 15px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #898b8d;
              }
            }
            .listbox {
              margin-top: 178px;
              margin-bottom: 235px;
              .listboxtit {
                height: 21px;
                font-size: 18px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #898b8d;
                line-height: 21px;
                text-align: center;
              }
              .listboxtit1 {
                margin-top: 6px;
                height: 16px;
                font-size: 14px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #898b8d;
                line-height: 16px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
.BlockList1 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
  .add_address {
    // margin-top: 10px;
    width: 590px;
    height: 341px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .add_close {
      margin-left: 550px;
      margin-top: 18px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .add_box {
      margin: 8px 40px 40px 40px;
      .add_tit {
        height: 33px;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
        text-align: center;
      }
      .add_tit1 {
        margin-top: 12px;
        height: 19px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        text-align: center;
        span {
          cursor: pointer;
          color: #00e79a;
          margin-left: 4px;
        }
      }
      .add_con {
        margin-top: 28px;
        .add_contit {
          height: 21px;
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #7f7f7f;
          line-height: 21px;
          margin-bottom: 14px;
        }
        .add_input {
          width: 510px;
          height: 48px;
          background: #000000;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          input {
            width: 510px;
            height: 48px;
            border: none;
            padding-left: 20px;
            color: #fff;
          }
        }
        .btn {
          width: 510px;
          height: 48px;
          background: #333b3b;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          margin-top: 28px;
          text-align: center;
          line-height: 48px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #858989;
        }
        .btn1 {
          width: 510px;
          height: 48px;
          background: #02d28e;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          margin-top: 28px;
          text-align: center;
          line-height: 48px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
          cursor: pointer;
          border: none;
        }
      }
    }
  }
}
.BlockList2 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  overflow: auto;
  .verify {
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 590px;
    height: 628px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    .verify_close {
      margin-left: 550px;
      margin-top: 18px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .verify_box {
      margin: 8px 40px 40px 40px;
      .verifytit {
        height: 33px;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
        text-align: center;
      }
      .verifytit1 {
        margin-top: 12px;
        height: 19px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        text-align: center;
        span {
          margin-left: 2px;
          cursor: pointer;
          color: #00e79a;
        }
      }
      .verifypt {
        margin-top: 36px;
        height: 21px;
        font-size: 18px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #898b8d;
        line-height: 21px;
        display: flex;
        justify-content: space-between;
        img {
          width: 22px;
          height: 22px;
        }
      }
      .verifypc {
        width: 510px;

        background: #000000;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        margin-top: 12px;

        .text {
          margin: 0 20px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 21px;
          padding: 16px 0px;
        }
      }
      .verifypc1 {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        input {
          width: 359px;
          padding: 0px 20px;
          height: 48px;
          background: #000000;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          border: none;
          color: #fff;
        }
        .button {
          width: 133px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background: #02d28e;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          font-size: 13px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
          cursor: pointer;
          word-spacing: 0px;
        }
      }
      .Ownership {
        width: 510px;
        height: 48px;
        background: #333b3b;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        margin-top: 40px;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #858989;
        cursor: pointer;
      }
      .Ownership1 {
        width: 510px;
        height: 48px;
        background: #02d28e;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        cursor: pointer;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #13161b;
      }
    }
  }
  .erweima {
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 305px;
    height: 412px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    .close {
      width: 24px;
      height: 24px;
      margin-top: 18px;
      margin-left: 265px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .erweitit {
      margin-top: 8px;
      text-align: center;
      height: 63px;
      font-size: 18px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #898b8d;
      line-height: 21px;
    }
    .imgborder {
      width: 200px;
      height: 200px;
      border: 10px solid #fff;
      margin-left: 50px;
      margin-top: 10px;
      .imgs {
        // margin-top: 10px;
        width: 180px;
        height: 180px;
        //  border: 1px solid red;
        // margin-left: 41px;
        z-index: 999999;
      }
    }

    .btton {
      margin-top: 26px;
      width: 238px;
      height: 43px;
      background: #02d28e;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      line-height: 43px;
      text-align: center;
      cursor: pointer;
      margin-left: 33px;
    }
  }
  // 删除开始
  .delet {
    width: 401px;
    height: 173px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .box {
      width: 428px;
      margin: 0 auto;
      .deletit {
        height: 33px;
        font-size: 20px !important;
        font-family: Roboto, Roboto !important;
        font-weight: 500 !important;
        color: #ffffff;
        line-height: 33px;
        word-spacing: -2px;
        margin-top: 44px;
      }
      // .delflex {
      //   display: flex;
      //   margin-top: 36px;
      //   .deleterr {
      //     width: 142px;
      //     height: 48px;
      //     line-height: 48px;
      //     border-radius: 10px;
      //     font-size: 16px;
      //     font-family: Roboto, Roboto;
      //     font-weight: 500;
      //     text-align: center;
      //     color: #04bf83;
      //     cursor: pointer;
      //     margin-left: 144px;
      //   }
      //   .deletok {
      //     width: 142px;
      //     height: 48px;
      //     line-height: 48px;
      //     border-radius: 10px;
      //     font-size: 16px;
      //     font-family: Roboto, Roboto;
      //     font-weight: 500;
      //     color: #13161b;
      //     text-align: center;
      //     background: #04bf83;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}
</style>
